/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management = {

  namespaced: true,
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/manifests`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * マニフェストの更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/manifests`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * マニフェストの取消
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/manifests`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {
  },

}

export default manifest_management
